export default __webpack_public_path__ + "static/media/attach_files_orange.d4bc566a.svg";